import { cloneDeep } from "lodash";
import baseReducer from "../../base/store/reducer";
import constants from "./constants";

const INITIAL_STATE = {
  all: {},
  allCopy: {},
  inProgress: [],
  paginations: {},
  paginationsCopy: {},
  filtered: {},
  filteredCopy: {},
  backgroundTasks: {},
  hasFetchedAll: false,
  forms: {},
  formInstance: {},
  formErrors: {},
  ads: [], // array of objs
  defaultSettings: {
    date_publish: null,
    access_date: null,
    pilot_mode: null,
    is_paused: false,
    prior_access: false,
    prioritize_customers: false,
    requirement: null,
    dump_in_pipe: null,
    description: "",
    publish_homeq: false,
    publish_pigello: false,
    publish_sbf: false,
  },
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  const newState = baseReducer(state, action, constants);

  switch (type) {
    case constants.ADD_APARTMENT: {
      return handleAddApartment(newState, payload);
    }

    case constants.ADD_MULTIPLE_APARTMENTS: {
      return handleAddMultipleApartments(newState, payload);
    }

    case constants.REMOVE_APARTMENT: {
      return handleRemoveApartment(newState, payload);
    }

    case constants.SET_ADS: {
      return { ...newState, ads: payload.newAds };
    }

    case constants.SET_DEFAULT_SETTINGS: {
      return { ...newState, defaultSettings: payload.settings };
    }

    case constants.CLEAR_NEW_PRODUCTION_FLOW_DATA: {
      return {
        ...newState,
        defaultSettings: INITIAL_STATE.defaultSettings,
        ads: [],
      };
    }

    default:
      return newState;
  }
};

const handleAddApartment = (state, payload) => {
  const { apartment } = payload;
  const stateClone = cloneDeep(state);

  const { ads } = stateClone;

  ads.push({
    ...apartment,
  });

  return stateClone;
};

const handleAddMultipleApartments = (state, payload) => {
  const { apartments } = payload;

  const stateClone = cloneDeep(state);

  const { ads } = stateClone;

  apartments.forEach((a) => {
    ads.push({
      ...a,
    });
  });

  return stateClone;
};

const handleRemoveApartment = (state, payload) => {
  const { apartment } = payload;
  const stateClone = cloneDeep(state);

  const { ads } = stateClone;

  const newAds = ads.filter((i) => i.id !== apartment.id);
  stateClone.ads = newAds;
  return stateClone;
};
